var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLevel2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21.515,
  height: 17.49
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "level2_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h21.515v17.49H0z",
  "data-name": "Rectangle 18365"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#level2_svg__a)",
  "data-name": "Group 644057"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ccc",
  d: "M20.515 2H10.1a1 1 0 1 1 0-2h10.415a1 1 0 0 1 0 2",
  "data-name": "Path 647952"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ccc",
  d: "M20.515 5.872H10.1a1 1 0 0 1 0-2h10.415a1 1 0 0 1 0 2",
  "data-name": "Path 647953"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ccc",
  d: "M20.515 9.745H10.1a1 1 0 1 1 0-2h10.415a1 1 0 0 1 0 2",
  "data-name": "Path 647954"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#772432",
  d: "M20.515 13.618H10.1a1 1 0 1 1 0-2h10.415a1 1 0 0 1 0 2",
  "data-name": "Path 647955"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#772432",
  d: "M20.515 17.49H10.1a1 1 0 1 1 0-2h10.415a1 1 0 0 1 0 2",
  "data-name": "Path 647956"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#004165",
  d: "M0 14.642v-1.273l1.075-1.415c1.452-1.918 2.868-3.782 2.868-5.682 0-1.093-.538-1.81-1.56-1.81a3.07 3.07 0 0 0-1.72.609L.287 3.6a4.35 4.35 0 0 1 2.437-.753c2.277 0 3.1 1.577 3.1 3.3 0 2.187-1.4 4.105-2.778 5.843l-.735.933v.035H6v1.685Z",
  "data-name": "Path 647957"
}))));
export { SvgLevel2 as ReactComponent };
export default __webpack_public_path__ + "92c7d90026b32375c2e44049448f77c2.svg";